import { styled } from '@linaria/react';

export const ECMMessageText = styled.p`
  text-align: center;
  font-weight: 400;
  font-size: 22px;
  line-height: 26px;
`;

export const ECMIconContainer = styled.div`
  border: 1px solid #e1e1e1;
  color: var(--bb-color-primary-0);
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
`;
